import SegmentIcon from '@clearkit/icons/glyphs/Segment';
import SegmentWithDestinationIcon from '@clearkit/icons/glyphs/SegmentDestination';

import styles from './styles.style';

function SegmentListIcon({ segment, classes, className }) {
  const {
    enabledDestinationsCount,
    audiences: { totalCount },
  } = segment;

  if (enabledDestinationsCount === 0 && totalCount === 0) {
    return <SegmentIcon className={classnames(className, classes.icon)} />;
  }

  return (
    <SegmentWithDestinationIcon
      className={classnames(
        className,
        classes.icon,
        classes.segmentWithDestinationsIcon,
      )}
    />
  );
}

SegmentListIcon.propTypes = {
  segment: PropTypes.shape({
    enabledDestinationsCount: PropTypes.number,
    audiences: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }).isRequired,
  classes: PropTypes.object,
  className: PropTypes.string,
};

export default withStyles(styles)(SegmentListIcon);
